<template>
  <nav class="bottom-nav" v-if="isVisible">
    <div class="bottom-nav-items">
      <!-- Company (Left) -->
      <router-link
        v-if="showCompany"
        to="/company/wall"
        class="bottom-nav-item"
        :class="{ active: isActive('/company') }"
      >
        <i class="bi bi-building"></i>
        <span>Company</span>
      </router-link>

      <!-- Home (Center) -->
      <router-link
        to="/workspace"
        class="bottom-nav-item"
        :class="{ active: isActive('/workspace') }"
      >
        <i class="bi bi-house"></i>
        <span>Home</span>
      </router-link>

      <!-- More (Right) -->
      <button
        class="bottom-nav-item"
        @click="$emit('open-menu')"
      >
        <i class="bi bi-grid"></i>
        <span>More</span>
      </button>
    </div>
  </nav>
</template>

<script setup>
import { computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

defineEmits(['open-menu']);

const route = useRoute();
const authStore = useAuthStore();
const isMobile = inject('isMobile', { value: false });

const isVisible = computed(() => isMobile.value);

// Permission helpers
const isSectionActive = (section, subsection) => {
  return authStore.isSectionActive(section, subsection);
};

const hasPermission = (section, subsection) => {
  return authStore.hasPermission(section, subsection);
};

const canAccess = (section, subsection) => {
  return isSectionActive(section, subsection) && hasPermission(section, subsection);
};

const isAdmin = computed(() => authStore.isAdmin);

// Show Company section if user has access to any company subsection
const showCompany = computed(() => {
  if (!isSectionActive('company', null)) return false;
  if (isAdmin.value) return true;
  return canAccess('company', 'news') ||
         canAccess('company', 'compliance') ||
         canAccess('company', 'resources') ||
         canAccess('company', 'orgchart') ||
         canAccess('company', 'okrs') ||
         canAccess('company', 'feedback-insights');
});

function isActive(path) {
  return route.path.startsWith(path);
}
</script>

<style scoped>
/* Styles are in main.css for global consistency */
</style>
